import { RootModel } from "types/rootModel.d";
import { model } from "./model";

export const models: RootModel = {
  ...model,
};
